import * as React from 'react';
import './ProductPrice.styles.less';
import {IProductPriceProps} from "./ProductPrice.types";

export const ProductPrice = (props:IProductPriceProps) =>
    <div className="ProductPrice">{props.priceRange}</div>
